import React, {Fragment} from "react";
import {Col, FormGroup, FormText, Input, Label, Row} from "reactstrap";
import {InputAdapter, TextMask} from "react-text-mask-hoc";
import {getFormFieldValue, setFormFieldValue} from '../shared/shared';
import {Address} from "./Address";

export function Beneficiary(props) {
  const {values, handleCB, readonly, token, formFields} = props;

  return (
    <Fragment>
      <Row>
        <Col xs={"9"}>
          <FormGroup>
            <Label htmlFor={"fullName"}>Full Name (First, Middle, Last)*</Label>
            <Input type="text" id={"fullName"} placeholder=""
                   value={getFormFieldValue(values.fullName)}
                   onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}/>
          </FormGroup>
        </Col>
        <Col xs={"3"}>
          <FormGroup>
            <Label htmlFor="ssn">SSN</Label>
            <TextMask
              mask={[/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
              Component={InputAdapter}
              className="form-control"
              id={"ssn"}
              value={getFormFieldValue(values.ssn)}
              onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}
            />
            <FormText color="muted">
              ex. 999-99-9999
            </FormText>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={"4"}>
          <FormGroup>
            <Label htmlFor="bdate">Date of Birth*</Label>
            <TextMask
              mask={[/[0-1]/, /\d/, '/', /[0-3]/, /\d/, '/', /[1-2]/, /[09]/, /\d/, /\d/]}
              Component={InputAdapter}
              className="form-control"
              id="bdate"
              value={getFormFieldValue(values.bdate)}
              onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}
            />
            <FormText color="muted">
              MM/DD/YYYY (ex. 08/26/1984)
            </FormText>
          </FormGroup>
        </Col>
        <Col xs={"4"}>
          <FormGroup>
            <Label htmlFor={"relationship"}>Relationship*</Label>
            <Input type="text" id={"relationship"} placeholder=""
                   value={getFormFieldValue(values.relationship)}
                   onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}/>
          </FormGroup>
        </Col>
        <Col xs={"4"}>
          <FormGroup>
            <Label htmlFor="phone">Home/Cell Phone*</Label>
            <TextMask
              mask={[/[2-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
              Component={InputAdapter}
              className="form-control"
              id="phone"
              value={getFormFieldValue(values.phone)}
              onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}
            />
            <FormText color="muted">
              ###-###-####
            </FormText>
          </FormGroup>
        </Col>
      </Row>

      {getFormFieldValue(values.useAddress) === "" && (
        <Address values={values || {}}
                 handleCB={(field, value) => setFormFieldValue(field, value, values, readonly, handleCB)}
                 thisId={"beneficiary"} readonly={readonly} formFields={formFields} token={token}/>
      )}
      <Row>
        <Col xs={"4"}>
          <FormGroup>
            <Label htmlFor="weight">Share %</Label>
            <TextMask
              mask={[/[0-9]/, /[0-9]/, /[0-9]/]}
              Component={InputAdapter}
              className="form-control"
              guide={false}
              showMask={false}
              id="share"
              value={getFormFieldValue(values.share)}
              onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}
            />
            <FormText color="muted">
              % (If all blank, equally distributed)
            </FormText>
          </FormGroup>
        </Col>
      </Row>

    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Applications/components/Beneficiary.js